import { CommonModule } from "@angular/common";
import { Component, computed, OnInit, output, Signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SignupV2Service } from "../../signup-v2.service";
import { handleImageError } from "../../../../shared/common/utils";
import { Frequencies } from "../../../../shared/types/common.types";
import { SectionLoaderComponent } from "../../../../shared/section-loader/section-loader.component";
import { LoaderSizeEnum } from "../../../../shared/section-loader/section-loader.types";

@Component({
    selector: 'app-subscriptions-step',
    imports: [CommonModule, FormsModule, SectionLoaderComponent],
    templateUrl: './subscriptions-step.component.html',
    styleUrl: './subscriptions-step.component.scss'
})
export class SubscriptionsStepComponent implements OnInit {
    // Output para comunicarse con el componente padre
    stepCompleted = output<void>();

    constructor(public svc: SignupV2Service) { }

    track = (_: number, s: any) => s.key;

    selectedIds = computed(() => this.svc.getSelectedExtraSubscriptions());
    frequencies = computed(() => this.svc.getFrequencies());

    isSubscriptionsLoading: Signal<boolean> = computed(() => this.svc.getIsExtraSubscriptionsLoading());

    LoaderSizeEnum = LoaderSizeEnum;

    get subs() { return this.svc.getExtraSubscriptions(); }

    ngOnInit() {
        this.svc.loadSubscriptionProductsIfNeeded();
        this.svc.loadFrequenciesIfNeeded();
    }

    toggle(id: number) { 
        this.svc.toggleExtraSubscription(id);
        // Initialize frequency selection for newly selected subscriptions
        if (this.isActive(id) && !this.svc.getSubscriptionFrequency(id)) {
            this.initializeFrequencyForSubscription(id);
        }
    }
    isActive(id: number) { return this.selectedIds().includes(id); }

    // Frequency management methods
    initializeFrequencyForSubscription(subscriptionId: number) {
        const frequencies = this.frequencies();
        if (frequencies.length > 0) {
            this.svc.setSubscriptionFrequency(subscriptionId, frequencies[0]);
        }
    }

    onFrequencyChange(subscriptionId: number, frequencyId: number) {
        const frequencies = this.frequencies();
        const selectedFrequency = frequencies.find(f => f.id === +frequencyId);
        if (selectedFrequency) {
            this.svc.setSubscriptionFrequency(subscriptionId, selectedFrequency);
        }
    }

    getSelectedFrequency(subscriptionId: number): Frequencies | null {
        return this.svc.getSubscriptionFrequency(subscriptionId);
    }


    onImageError = handleImageError;

    async onNext() {
        if (!this.svc.canProceed('subscriptions')) return;
        const isCompleted = await this.svc.markCompleted('subscriptions');
        if (isCompleted) {
            this.stepCompleted.emit();
        }
    }
}
